import { useI18nContext } from "@hopper-b2b/i18n";
import { useChatSupport } from "@hopper-b2b/self-serve";
import {
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";

import { ContactSupportModalContent } from "../ContactSupportModalContent";

interface ExchangeContactAirlineScreenProps {
  onBack?: () => void;
  [key: string]: unknown;
}

const ExchangeContactAirlineScreen = ({
  onBack,
}: ExchangeContactAirlineScreenProps) => {
  const { t } = useI18nContext();
  const { generalSupportChat } = useChatSupport();

  const handleClose = onBack ?? (() => {});
  const handleOpenChat = () => {
    handleClose();
    generalSupportChat();
  };

  return (
    <MobilePopoverCard
      fullScreen
      open
      className="contact-support-modal-content-container"
      onClose={handleClose}
      topRightButton={
        <ActionLink
          onClick={handleClose}
          content={
            <IconComponent
              ariaLabel={t("modalClose.ariaLabel")}
              className="close-button-icon"
              name={IconName.Close}
            />
          }
        />
      }
    >
      <ContactSupportModalContent
        onClose={handleClose}
        onContactSupport={handleOpenChat}
        title={t("exchange.contactTitle")}
        subtitle={t("exchange.contactSubtitle")}
      />
    </MobilePopoverCard>
  );
};

export default ExchangeContactAirlineScreen;
